class SecurityDepositPostponeModal {
    /** @ngInject */
    constructor($timeout, $state) {
        this.$timeout = $timeout
        this.$state = $state
    }

    doLogout() {
        this.dismiss()
        this.$timeout(() => this.$state.go('logout', {}, { reload: true }))
    }
}

export default {
    template: require('./securityDepositPostponeModal.jade')(),
    controller: SecurityDepositPostponeModal,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&', // {$value: myRejectedResult}
    },
}



// WEBPACK FOOTER //
// ./src/states/securityDepositSummary/modal/securityDepositPostponeModal.js